module.exports = __webpack_public_path__ + "img/06024.23ba1bd7.png";